import $ from 'jquery';

const $graph = $( '.c-reportiv-graph' );
const $graphSVG = $( '.c-reportiv-graph svg' );

if ( $graphSVG.length ) {
	const $clip = $( '#curves-clip rect', $graphSVG );
	let $hiddenElements = $( '> text', $graphSVG );
	let $lines = $( '.graph-line', $graphSVG );

	let x = 0;
	let startTime = false;
	let progress = 0;
	const duration = 3 * 1000;

	const showHiddenElement = function( x, index, element ) {
		const $element = $( element );
		const elX = parseFloat( $element.attr( 'x' ) );

		if ( x >= ( elX + 10 ) ) {
			$element.css( 'opacity', 1 );
			return false;
		}

		return true;
	};

	const easeInOut = function( t ) {
		if ( t < .5 ) {
			return 2 * t * t;
		}

		return -1 + ( 4 - ( 2 * t ) ) * t;
	};

	const animateLine = function( x, index, line ) {
		const $line = $( line );
		const lineX = parseFloat( $line.attr( 'x' ) );
		let progress = 0;

		if ( x >= ( lineX - 400 ) && x < ( lineX + 200 ) ) {
			progress = ( x - ( lineX - 400 ) ) / 600;
		}

		if ( x >= ( lineX + 200 ) || x >= 1600 ) {
			progress = 1;
		}

		progress = easeInOut( progress );

		$line.attr( 'transform', 'translate(0,-' + ( progress * 652 ) + ')' );

		if ( progress >= 1 ) {
			return false;
		}

		return true;
	};

	const tick = function( timestamp ) {
		if ( false === startTime ) {
			startTime = timestamp;
		}

		progress = ( timestamp - startTime ) / duration;

		if ( progress >= 1 ) {
			progress = 1;
		}

		progress = easeInOut( progress );

		x = progress * 1600;
		$clip.attr( 'transform', 'translate(' + x + ',0)' );

		if ( $hiddenElements.length ) {
			$hiddenElements = $hiddenElements.filter( showHiddenElement.bind( undefined, x ) );
		}

		if ( $lines.length ) {
			$lines = $lines.filter( animateLine.bind( undefined, x ) );
		}

		if ( 1 > progress ) {
			requestAnimationFrame( tick );
		}
	};

	const start = function() {
		requestAnimationFrame( tick );
	};

	if ( $graph.hasClass( 'in-view' ) ) {
		start();
	} else {
		$graph.on( 'majik.reveal.inView', start );
	}
}
